module.exports = __webpack_public_path__ + "static/img/icon_pro2s.745a398.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_pro2s.png
// module id = Ht8h
// module chunks = 11